import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Label + control wrapper. Put the grid span on the host, e.g. `<app-form-field class="jf-col-4">`.
 * `locked` shows the "Quick edit this" pill; `(unlock)` fires when it is clicked.
 */
@Component({
  selector: 'app-form-field',
  template: `
    <div class="jf-label" *ngIf="label || locked">
      <span>{{ label }} <em *ngIf="required">*</em></span>
      <ng-content select="[fieldLabelExtra]"></ng-content>
      <button
        *ngIf="locked"
        type="button"
        class="jf-qe"
        [class.jf-qe--icon]="compactQuickEdit"
        [attr.title]="compactQuickEdit ? 'Quick edit this' : null"
        (click)="unlock.emit()">
        <i class="pi pi-pencil"></i><ng-container *ngIf="!compactQuickEdit"> Quick edit this</ng-container>
      </button>
    </div>
    <ng-content></ng-content>
    <p class="jf-hint" *ngIf="hint"><i class="pi pi-info-circle"></i> {{ hint }}</p>
    <div class="jf-error" *ngIf="error">{{ error }}</div>
  `,
  host: { class: 'jf-field' },
})
export class FormFieldComponent {
  @Input() label = '';
  @Input() required = false;
  @Input() locked = false;
  @Input() compactQuickEdit = false;
  @Input() hint = '';
  @Input() error = '';

  @Output() unlock = new EventEmitter<void>();
}
